import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { BaseApiTemplateService, Core2Config, Pagination, ApiVisa } from "../shared";
import { VendorLoginSubjectLinkContainerModel } from "../../../../../models/aggregates/vendor/vendor-login-subject-link-container.model";

@Injectable({ providedIn: "root" })
export class VendorLoginSubjectLinkService extends BaseApiTemplateService<VendorLoginSubjectLinkContainerModel> {
  constructor(http: HttpClient) {
    super();
    this.apiUrl =
      Core2Config.DOMAIN_URL +
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX +
      "vendor-login-subject-links";
    this.endpoint_path =
      Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "vendor-login-subject-links";
    this.httpClient = http;
  }

  private setUrl(endpoint: string){
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "vendor-login-subject-links" + endpoint;
    this.endpoint_path = Core2Config.PLATFORM_DOMAIN_URL_PREFIX + "vendor-login-subject-links" + endpoint;
  }

  sysadminGetByCriteria(pagination: Pagination, apiVisa: ApiVisa){
    this.setUrl('/sysadmin-ep');
    return super.getByCriteria(pagination, apiVisa);
  }
}
